import React from 'react'
import PropTypes from 'prop-types'
import Anime from '../../components/Anime/Anime'

const Selector = ({
  children,
  updateScore,
  score,
  nextStepUrl,
  id,
  currentSelectedAnswer,
  label,
  visibleLabel,
  stepNumber,
  answerString
}) =>
  <Anime
    scaleX={currentSelectedAnswer === id ? [1.4, 1.2] : [1.2, 1]}
    scaleY={currentSelectedAnswer === id ? [0.9, 1.2] : [1.2, 1]}
    opacity={currentSelectedAnswer === id ? 1 : 0.8}
    elasticity={currentSelectedAnswer === id ? 600 : 300}
  >
    <div
      style={{ outline: 'none', opacity: 1 }}
      className="h-100 pa3"
      data-test="selector-button"
      role="button"
      tabIndex="0"
      aria-label={`Svar med ${label.toLowerCase()}`}
      onClick={() => updateScore(score, id, stepNumber, answerString)}
      onKeyDown={e =>
        (e.keyCode === 13 || e.keyCode === 32) &&
        updateScore(score, id, stepNumber, answerString)}
    >
      {children}
      {visibleLabel &&
        <h4 className="mt2 mb4 primary-font-bold white f3">
          {label}
        </h4>}
    </div>
  </Anime>

Selector.propTypes = {
  children: PropTypes.object,
  updateScore: PropTypes.func.isRequired,
  score: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  currentSelectedAnswer: PropTypes.number,
  label: PropTypes.string.isRequired
}

export default Selector



// WEBPACK FOOTER //
// ./src/components/Selector/Selector.js